import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

export const useTranslation = () => {
    const { t, i18n: i18nInstance } = useI18nTranslation();
    const { selectedLanguage, direction } = useSelector(state => state.language);

    useEffect(() => {
        if (selectedLanguage && i18nInstance.language !== selectedLanguage) {
            i18nInstance.changeLanguage(selectedLanguage);
        }
        // Ensure document direction and language match the state
        document.documentElement.dir = direction;
        document.documentElement.lang = selectedLanguage || 'en';
    }, [selectedLanguage, direction, i18nInstance]);

    return {
        t,
        currentLanguage: selectedLanguage || 'en',
        direction,
        isRTL: direction === 'rtl'
    };
};